import { render, staticRenderFns } from "./Oops.vue?vue&type=template&id=4f15deca"
import script from "./Oops.vue?vue&type=script&lang=ts"
export * from "./Oops.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports